import cityService from '../../../services/location/CityService';
import i18n from "../../../i18n/index";

export default {
    data() {
        return {
            search: "",
            headers: [{
                text: 'Municipio',
                sortable: false,
                value: "name"
            }, {
                text: 'Code',
                sortable: false,
                value: "code"
            }, {
                text: 'Departamento',
                sortable: false,
                value: "idState"
            }],
            itemsData: [],
            nroRows: 0
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.searchCity();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        searchCity() {
            cityService.getCities().then(response => {
                this.itemsData = response.data;
                this.nroRows = response.data.length;
            });
        },
        getLenght() {
            console.log(this.nroRows)
            return this.nroRows;
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase();
            return items.filter(row => filter(row["name"], search));
        }
    }
};